export default __webpack_public_path__ + "static/media/landing.afd9f868.jpeg";